import React, { useState, useEffect } from 'react'
import { getIntegrationDetails } from '@demo-system/commons/utilities/integrations'
import { getNewestDataset } from '@demo-system/commons/utilities/datasets'
import { fetchSandboxDetails } from '@demo-system/commons/service'
import { useProject } from 'hooks'
import { fetch } from 'services/axios'
import Wait from '@react/react-spectrum/Wait'

import './DefaultDataset.scss'

export default function DefaultDataset({ datasetName }) {
  const { project } = useProject()
  const { orgId, sandboxName } = getIntegrationDetails(project?.integrations)
  const [dataset, setDataset] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (orgId && sandboxName) {
      setLoading(true)
      fetch(fetchSandboxDetails, { orgId, sandboxName, include: 'datasets', datasetName })
        .then((res) => {
          setDataset(getNewestDataset(res?.datasets))
          setError(null)
          setLoading(false)
        })
        .catch((err) => {
          setError(err)
          setLoading(false)
        })
    }
  }, [setError, setLoading, setDataset, datasetName, orgId, sandboxName])

  let contentHeader = null

  if (loading) {
    contentHeader = (
      <>
        <Wait size='S' className='DefaultDataset__Wait' />
        Loading the default dataset
      </>
    )
  } else if (error) {
    contentHeader = 'An error occurred while loading the default dataset information'
  } else if (!dataset) {
    contentHeader = 'No default dataset found'
  } else {
    contentHeader = 'Default dataset:'
  }

  return (
    <div className='DefaultDataset'>
      <div>{contentHeader}</div>
      {dataset && (
        <span>
          <strong>{dataset.name}</strong> ({dataset.id})
        </span>
      )}
    </div>
  )
}
